var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Button, Card } from "syf-component-library/ui/atoms";
var EditButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 3rem 0;\n  width: 100%;\n  max-width: 225px;\n"], ["\n  margin: 3rem 0;\n  width: 100%;\n  max-width: 225px;\n"])));
export var ProfileSectionContent = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  overflow: visible;\n"], ["\n  ", "\n  overflow: visible;\n"])), function (_a) {
    var hidden = _a.hidden;
    return hidden && "display: none;";
});
export default EditButton;
var templateObject_1, templateObject_2;
